import React from "react";
import { Typography, Progress } from "../../core";
import styled from "styled-components";
import { media } from "../../styles";
import { useSelector } from "react-redux";
import { Row, Col } from "antd";
import CountUp from "react-countup";
const PERCENTAGE_CALCULAT = require("../../helper/utils/Percentage");
const BuyerShortDetail = styled.div`
  padding: 5px;
  h2 {
    ${media.minitablet`font-size:30px;`}
    text-align:center;
    span {
      margin-right: 5px;
      font-size: 24px;
      line-height: 36px;
    }
  }
  h6 {
    ${media.minitablet`font-size:13px;`}
  }
`;

const Statistic = ({ data }) => {
  console.log(data.id);
  const contracts = useSelector(
    (state) => state.contractReducer.contracts
  ).filter((contract_item) => {
    return contract_item.buyer_id === data.id;
  });
  console.log("contracts", contracts);
  const recieved_payments = useSelector(
    (state) => state.addBuyer.buyer_payments
  )
    .filter((invocie_items) => {
      return (
        invocie_items.buyer_id === data.id &&
        invocie_items.payment_option === "receive"
      );
    })
    .map((invoice_Item) => {
      return parseInt(invoice_Item.payment_amount);
    })
    .reduce((acc, curr) => acc + curr, 0);
  const Invoice_payemnt = useSelector((state) => state.contractReducer.invoices)
    .filter((invocie_items) => {
      return invocie_items.buyer_id === data.id;
    })
    .map((invoice_Item) => {
      return parseInt(invoice_Item.total_value_include_sale_tax);
    })
    .reduce((acc, curr) => acc + curr, 0);
  const pending_payemnt = Invoice_payemnt - recieved_payments;
  console.log("Invoice", pending_payemnt);
  const total_contract = contracts.length;
  const contract_inProgress = contracts.filter((buyer_contract) => {
    return buyer_contract.contract_status === "In progress";
  }).length;
  const contract_completed = contracts.filter((buyer_contract) => {
    return buyer_contract.contract_status === "completed";
  }).length;

  const contract_inprogress_percent = PERCENTAGE_CALCULAT.percentage(
    contract_inProgress,
    total_contract
  );

  const contract_complete_percent = PERCENTAGE_CALCULAT.percentage(
    contract_completed,
    total_contract
  );
  const pending_payment_percent = PERCENTAGE_CALCULAT.percentage(
    pending_payemnt,
    Invoice_payemnt
  );
  const received_payment_percent = PERCENTAGE_CALCULAT.percentage(
    recieved_payments,
    Invoice_payemnt
  );

  console.log("contract_inprogress_percent", contract_inprogress_percent);
  return (
    <Row type="flex" justify="space-around" gutter={[32, 32]}>
      <Col lg={6} sm={10} xs={12}>
        <ShortDetail
          value={contract_completed}
          tittle="Completed Contract"
          status="contract-complete"
          percentage={contract_complete_percent}
        />
      </Col>
      <Col lg={6} sm={10} xs={12}>
        <ShortDetail
          value={contract_inProgress}
          tittle="In Progress"
          status="in-progress"
          percentage={contract_inprogress_percent}
        />
      </Col>
      <Col lg={6} sm={10} xs={12}>
        <ShortDetail
          type="payment"
          value={pending_payemnt}
          tittle="Pending Payment"
          status="pending-payment"
          percentage={pending_payment_percent}
        />
      </Col>
      <Col lg={6} sm={10} xs={12}>
        <ShortDetail
          type="payment"
          value={recieved_payments}
          tittle="Received Payment"
          status="received-payment"
          percentage={received_payment_percent}
        />
      </Col>
    </Row>
  );
};
const ShortDetail = ({ value, tittle, status, type, percentage }) => (
  <BuyerShortDetail>
    <Typography as="h2" weight="500" aliggn="center" noMargin>
      {type ? <span className="themed--color_green">RS</span> : ""}
      <CountUp
        // decimals={4}
        start={0}
        end={value}
        duration={2.75}
        separator=","
      />
      {/* {value} */}
    </Typography>
    <Typography as="h6" color="#949aa6" align="center">
      {tittle}
    </Typography>
    <Progress
      bgcolor={status}
      showInfo={false}
      percent={percentage}
      size="small"
    />
  </BuyerShortDetail>
);
ShortDetail.defaultProps = {
  percent: 1,
};
export default Statistic;
